import Vue from 'vue'
import Vuetify from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'
import '@/scss/overrides.sass'

import IconBox from '@/components/icons/IconBox'
import IconSetting from '@/components/icons/IconSetting'
import IconStore from '@/components/icons/IconStore'
import IconUser from '@/components/icons/IconUser'
import IconLogout from '@/components/icons/IconLogout'
import IconLogoOctipas from '@/components/icons/IconLogoOctipas'
import IconDashboard from '@/components/icons/IconDashboard'
import IconClickAndCollect from '@/components/icons/IconClickAndCollect'
import IconClickAndReserve from '@/components/icons/IconClickAndReserve'
import IconReturn from '@/components/icons/IconReturn'
import IconOctiStock from '@/components/icons/IconOctiStock'
import IconTemplatesManager from '@/components/icons/IconTemplatesManager'
import IconParsingsHistory from '@/components/icons/IconParsingsHistory'
import IconPhone from '@/components/icons/IconPhone'
import IconWeb from '@/components/icons/IconWeb'
import IconDelivery from '@/components/icons/IconDelivery'
import IconDigitalInStore from '@/components/icons/IconDigitalInStore'
import IconTasks from '@/components/icons/IconTasks'
import IconConfigurationManager from '@/components/icons/IconConfigurationManager'
import IconTriggers from '@/components/icons/IconTriggers'
import IconCopy from '@/components/icons/IconCopy'
import { defaultTheme } from '../helpers/constante'
import { i18n } from '../i18n'

const themes = structuredClone(defaultTheme.theme)

Vue.use(Vuetify)
const opts = {
  icons: {
    iconfont: 'mdi',
    values: {
      box: {
        component: IconBox,
      },
      store: {
        component: IconStore,
      },
      user: {
        component: IconUser,
      },
      setting: {
        component: IconSetting,
      },
      logout: {
        component: IconLogout,
      },
      logo: {
        component: IconLogoOctipas,
      },
      dashboard: {
        component: IconDashboard,
      },
      click_and_collect: {
        component: IconClickAndCollect,
      },
      click_and_reserve: {
        component: IconClickAndReserve,
      },
      return: {
        component: IconReturn,
      },
      octistock: {
        component: IconOctiStock,
      },
      templatesManager: {
        component: IconTemplatesManager,
      },
      parsingsHistory: {
        component: IconParsingsHistory,
      },
      phone: {
        component: IconPhone,
      },
      web: {
        component: IconWeb,
      },
      delivery: {
        component: IconDelivery,
      },
      digitalInStore: {
        component: IconDigitalInStore,
      },
      tasks: {
        component: IconTasks,
      },
      configurationManager: {
        component: IconConfigurationManager,
      },
      triggers: {
        component: IconTriggers,
      },
      copy: {
        component: IconCopy,
      },
    },
  },
  theme: {
    themes: {
      light: {
        primary: themes.light.primary_color,
        primary_text_color: themes.light.primary_text_color,
        drawer_color: themes.light.drawer_color,
        drawer_text_color: themes.light.drawer_text_color,
        data_table_header_color: themes.light.data_table_header_color,
        data_table_header_text_color: themes.light.data_table_header_text_color,
        app_bar_color: themes.light.app_bar_color,
        app_bar_text_color: themes.light.app_bar_text_color,
        text_color: themes.light.text_color,
      },
      dark: {
        primary: themes.dark.primary_color,
        primary_text_color: themes.dark.primary_text_color,
        secondary: themes.dark.secondary_color,
        drawer_color: themes.dark.drawer_color,
        drawer_text_color: themes.dark.drawer_text_color,
        data_table_header_color: themes.dark.data_table_header_color,
        data_table_header_text_color: themes.dark.data_table_header_text_color,
        app_bar_color: themes.dark.app_bar_color,
        app_bar_text_color: themes.dark.app_bar_text_color,
        text_color: themes.dark.text_color,
      },
    },
    options: { customProperties: true },
  },
  // change in the internationalization to use vue-i18n
  // see: https://v2.vuetifyjs.com/en/features/internationalization/#vue-i18n
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
}

export default new Vuetify(opts)
